module.exports = __webpack_public_path__ + "static/media/icon-symptoms-sore-throat.691c7d8a.svg";